import { render, staticRenderFns } from "./IFrameLearningPage.vue?vue&type=template&id=23155534&scoped=true&"
import script from "./IFrameLearningPage.vue?vue&type=script&lang=js&"
export * from "./IFrameLearningPage.vue?vue&type=script&lang=js&"
import style0 from "./IFrameLearningPage.vue?vue&type=style&index=0&id=23155534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23155534",
  null
  
)

export default component.exports